import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Api } from '../../contracts/classes/api.class';

@Injectable({
    providedIn: 'root'
})
export class UbigeoService extends Api {


    getRegiones(): Observable<any> {
        return this.http.get(`${this.url}/ubigeo/regiones`);
    }

    getProvincias(regionId: string): Observable<any> {
        return this.http.get(`${this.url}/ubigeo/provincias/${regionId}`);
    }

    getDistritos(provinciaId: string): Observable<any> {
        return this.http.get(`${this.url}/ubigeo/distritos/${provinciaId}`);
    }

    // Nuevos métodos añadidos
    getMedioConUbigeo(id: number): Observable<any> {
        return this.http.get(`${this.url}/ubigeo/medio/${id}`);
    }

    updateMedioConUbigeo(id: number, medio: any): Observable<any> {
        return this.http.put(`${this.url}/ubigeo/medio/${id}`, medio);
    }

    getCountries(): Observable<any> {
        return this.http.get(`${this.url}/countries`)
    }

    getRegions(regionID: number): Observable<any> {
        return this.http.get(`${this.url}/regions/${regionID}`)
    }

    getDepartment(): Observable<any> {
        return this.http.get(`${this.url}/ubigeo/regiones`)
    }

    getProvinces(regionId: number): Observable<any> {
        return this.http.get(`${this.url}/ubigeo/provincias/${regionId}`)
    }

    getDistrict(provinciaId: number): Observable<any> {
        return this.http.get(`${this.url}/ubigeo/distritos/${provinciaId}`)
    }

}